// Quantity to order: rounded up to a multiple of the item's order multiple (pieces per pack, synced from
// Snowflake), as the backend's utils.ToOrderQuantity does. 1 - legacy items - or missing leaves it unchanged.
export const toOrderQuantity = (quantity: number, minOrderQuantity: number | undefined): number => {
  const multiple = minOrderQuantity && minOrderQuantity > 0 ? minOrderQuantity : 1;

  return Math.ceil(quantity / multiple - 1e-9) * multiple;
};
